<template>
    <div class="notification-create-container">
        <NotificationForm
            title="Create Notification"
            @cancel="cancel"
            @post="post"
        ></NotificationForm>
    </div>
</template>

<script>
import * as notificationModule from '@/store/notification'
import NotificationForm from '@/components/notification/NotificationForm.vue'

export default {

	async beforeRouteLeave (to, from, next) {
		const hasValues = await this.$store.dispatch('notification/hasValues')
		if (hasValues) {
			// this.$store.commit('modal/toggleModal', {
			// 	modalName: 'not-empty-form',
			// 	action: () => {
			// 		this.$store.dispatch('modal/closeModal')
			// 		this.$store.dispatch('notification/clearData')
			// 		next()
			// 	}
			// })

            this.$store.commit('modal/toggleModal', {
                modalType: 'warning',
                modalName: 'confirm-modal',
                modalDesc: 'Your input will be lost.',
                action: () => {
					this.$store.dispatch('modal/closeModal')
					this.$store.dispatch('notification/clearData')
					next()
				}
            })

			return
		}

		this.$store.dispatch('notification/clearData')
		next()
	},

	beforeCreate () {
		if (!this.$store._modulesNamespaceMap['notification/']) {
			this.$store.registerModule('notification', notificationModule.default)
		}
	},

	// async created () {
	// 	await this.$store.dispatch('notification/getCountryList')
	// },

	methods: {
		cancel () {
			this.$router.push({ name: 'notification-post' })
		},

		async post (form) {
			await this.$store.dispatch('notification/create', { form })
		}
	},

	components: {
		NotificationForm
	}
}
</script>

<style lang="scss" scoped>
.notification-create-container {
	padding-left: calc(100px - 1em);
	padding-top: 2em;
	padding-bottom: 2em;
	width: 100%;
	height: 100%;
	overflow: auto;
}
</style>
